var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowAllImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.627 11.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.502 16.25a2.5 2.5 0 0 1-2.5 2.5h-12.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 2.5 3.75 2.5 2.5 0 0 1 5 1.25h12.5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.498 2.5ZM17.5 2.5H5c-.69 0-1.25.56-1.25 1.25h11.252a2.5 2.5 0 0 1 2.5 2.5V15a1.25 1.25 0 0 0 1.248-1.25v-10c0-.69-.56-1.25-1.25-1.25ZM2.502 5c-.69 0-1.25.56-1.25 1.25v10l3.308-2.942c.21-.21.54-.243.789-.078l3.323 2.216 4.638-4.638c.19-.19.48-.237.721-.117l2.22 2.434V6.25c0-.69-.559-1.25-1.25-1.25h-12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAllImg);
export default __webpack_public_path__ + "static/media/show-all-img.fcebed1a99ab32d154268178c3a36226.svg";
export { ForwardRef as ReactComponent };